<template>
  <footer>
    <a
      variant="transparant mb-3 mb-md-0 p-0 ml-md-0 mr-md-auto"
      href="https://seoro-malgm.me/"
      target="_blank"
      role="link button"
    >
      <img
        src="@/assets/seoro-malgm-logo.png"
        alt="서로맑음 로고, 메인페이지로 이동"
        class="not-print"
        :style="{ width: '7rem' }"
      />
    </a>
    <div class="copyright">
      <small>&copy; All Copyrights Seoro-Malgm reserved.</small>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
